import React from "react";
import PropTypes from "prop-types";
import Image from "../img/lifequality.png";
import "./LifeQualityHeader.scss";

function LifeQualityHeader({
  style = {},
  href = "https://www.s-bahn-muenchen.de/",
  alt = "#MitEuchUnterwegs Steig ein für ein lebenswertes München.",
  image = Image,
}) {
  return (
    <a
      className="diversity-header"
      href={href}
      target="_blank"
      rel="noreferrer"
      style={style}
    >
      <img src={image} alt={alt} />
    </a>
  );
}

LifeQualityHeader.propTypes = {
  style: PropTypes.object,
  href: PropTypes.string,
  alt: PropTypes.string,
  image: PropTypes.string,
};

export default React.memo(LifeQualityHeader);
